// @ts-expect-error missing dependency types
import dispatcher from 'dispatcher/dispatcher';
export default ((actionType, data) => {
  return dispatcher.dispatch({
    actionType,
    data
  });
});